import {KeyValue} from './keyValue';

export class Endpoint extends KeyValue {

    constructor() {
        super();
    }
    resourceCode: string;
    uri: string;
}